export default [
  {
    path: "/",
    name: "landing",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "landing" */ "pages/Landing.vue"
      ),
  },

  {
    path: "/guide/:document",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "guide" */ "pages/guide.vue"
      ),
    props: true,
  },

  {
    path: "/samples/escritorio",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "samples" */ "pages/samples/escritorio.vue"
      ),
    props: true,
  },

  {
    path: "/pages",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "layouts/MainLayout.vue"
      ),
    children: [
      {
        path: "/bi",
        name: "bi",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Bi.vue"
          ),
        meta: {
          caption: "Dashboard",
          icon: "las la-chart-bar",
          requiresAuth: true,
          keepAlive: true,
        },
        props: true,
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Dashboard.vue"
          ),
        meta: {
          caption: "Dashboard",
          icon: "las la-chart-bar",
          requiresAuth: true,
          keepAlive: true,
        },
        props: true,
      },
      {
        path: "/home",
        name: "home",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Home.vue"
          ),
        meta: {
          requiresAuth: true,
          keepAlive: true,
          title: "Início",
        },
        props: true,
      },
      {
        path: "/preambulo",
        name: "preambulo",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Preambulo.vue"
          ),
        meta: {
          requiresAuth: true,
          keepAlive: true,
          title: "Preâmbulo",
        },
        props: true,
      },
      {
        path: "/process",
        name: "process",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Process.vue"
          ),
        meta: {
          icon: "las la-gavel",
          requiresAuth: true,
          keepAlive: true,
          title: "Processos",
        },
        props: true,
      },
      {
        path: "/data/:table",
        name: "data",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Data.vue"
          ),
        meta: {
          icon: "las la-folder-open",
          requiresAuth: true,
          keepAlive: true,
          title: "Cadastro",
        },
        props: true,
      },
      {
        path: "/settings",
        name: "settings",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Settings.vue"
          ),
        meta: {
          requiresAuth: true,
          keepAlive: true,
          title: "Configurações",
        },
        props: true,
        children: [
          {
            path: "preferences",
            name: "preferences",
            component: () =>
              import(
                /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Preferences.vue"
              ),
            meta: {
              caption: "Configurações",
              icon: "las la-sliders-h",
              requiresAuth: true,
              keepAlive: true,
              title: "Preferências",
            },
            props: true,
          },
          {
            path: "info",
            name: "info",
            component: () =>
              import(
                /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Info.vue"
              ),
            meta: {
              caption: "Configurações",
              icon: "las la-info-circle",
              requiresAuth: true,
              keepAlive: true,
              title: "Informações",
            },
            props: true,
          },
          {
            path: "maintenance",
            name: "maintenance",
            component: () =>
              import(
                /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Maintenance.vue"
              ),
            meta: {
              caption: "Configurações",
              icon: "las la-wrench",
              requiresAuth: true,
              keepAlive: true,
              title: "Manutenção",
            },
            props: true,
          },
          {
            path: "provider",
            name: "provider",
            component: () =>
              import(
                /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Provider.vue"
              ),
            meta: {
              requiresAuth: true,
              keepAlive: true,
              showHeader: false,
            },
            props: true,
          },
        ],
      },
      {
        path: "/schedule",
        name: "schedule",
        component: () =>
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: "connect" */ "pages/Schedule.vue"
          ),
        meta: {
          icon: "las la-calendar",
          requiresAuth: true,
          keepAlive: true,
          title: "Agenda",
        },
        props: true,
      },
    ],
  },

  {
    // Always leave this as last one
    path: "/:catchAll(.*)*",
    component: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "error" */ "pages/Error"
      ),
    props: true,
  },
];
